import styled from "@emotion/styled"
import { ORANGE_COLOR } from "theme/colors"
import { BOX_SHADOW } from "theme/styles"
import IconContainer from "./IconContainer"
import { ComponentProps } from "react"

const Root = styled.div<{ size: number }>`
  width: ${(p) => `${p.size}px`};
  height: ${(p) => `${p.size}px`};
  background-color: ${ORANGE_COLOR};
  border-radius: ${(p) => `${p.size / 2}px`};
  ${BOX_SHADOW};
  position: absolute;
  top: calc(50% - ${(p) => `${p.size / 2}px`});
  left: calc(50% - ${(p) => `${p.size / 2}px`});
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

type Props = Omit<ComponentProps<typeof Root>, "size"> & {
  size?: number
}

export const LargePlayButton = ({ size = 160, ...props }: Props) => {
  return (
    <Root {...props} size={size}>
      <IconContainer
        url="/icons/player/ico_play_wh.svg"
        width={`${size / 2}px`}
        height={`${size / 2}px`}
        data-id="large-play-button"
      />
    </Root>
  )
}
